import { render, staticRenderFns } from "./PhoneLoginView.vue?vue&type=template&id=c445b052&scoped=true"
import script from "./PhoneLoginView.vue?vue&type=script&lang=js"
export * from "./PhoneLoginView.vue?vue&type=script&lang=js"
import style0 from "./PhoneLoginView.vue?vue&type=style&index=0&id=c445b052&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c445b052",
  null
  
)

export default component.exports